/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SessionStatusEnum {
    SESSION_STATUS_INVALID = 'SESSION_STATUS_INVALID',
    SESSION_STATUS_SESSION_CREATED = 'SESSION_STATUS_SESSION_CREATED',
    SESSION_STATUS_MEASUREMENT_DATA_CAPTURED = 'SESSION_STATUS_MEASUREMENT_DATA_CAPTURED',
    SESSION_STATUS_PRESCRIPTION_CREATED = 'SESSION_STATUS_PRESCRIPTION_CREATED',
    SESSION_STATUS_PRESCRIPTION_UPDATED = 'SESSION_STATUS_PRESCRIPTION_UPDATED',
    SESSION_STATUS_PRESCRIPTION_COMPLETED = 'SESSION_STATUS_PRESCRIPTION_COMPLETED',
    SESSION_STATUS_ORDER_CREATED = 'SESSION_STATUS_ORDER_CREATED',
    SESSION_STATUS_ORDER_CANCELLED = 'SESSION_STATUS_ORDER_CANCELLED',
    SESSION_STATUS_ORDER_DELIVERED = 'SESSION_STATUS_ORDER_DELIVERED',
    SESSION_STATUS_REPAIR_ORDER_CREATED = 'SESSION_STATUS_REPAIR_ORDER_CREATED',
}
